import { LogLevel, PublicClientApplication, type Configuration } from "@azure/msal-browser";
import { env } from "@/config/env";

const baseUrl = import.meta.env.BASE_URL.replace(/\/$/, '');
const redirectUri = `${window.location.origin}${baseUrl}/`;

export const msalConfig: Configuration = {
  auth: {
    authority: env.VITE_AZURE_AD_AUTHORITY,
    clientId: env.VITE_AZURE_AD_CLIENT_ID,
    redirectUri: redirectUri,
    postLogoutRedirectUri: redirectUri
  },
  cache: {
    cacheLocation: "sessionStorage"
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
        else if (level === LogLevel.Warning) console.warn(message);
        else if (level === LogLevel.Info) console.info(message);
      },
      logLevel: LogLevel.Info,
    },
  },
};

// Prefer the API's exposed scope; fall back to the app registration's .default when unset.
const apiScopes = [env.VITE_API_SCOPE ?? `${env.VITE_MSAL_CLIENT_ID}/.default`];

export const loginRequest = {
  scopes: ['openid', 'profile', 'email', ...apiScopes],
};

export const apiTokenRequest = {
  scopes: apiScopes,
};

export const msalInstance = new PublicClientApplication(msalConfig);


